module.exports = __webpack_public_path__ + "button-arrow.svg?96b75274c40bb7789e197066cc0cee8f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-arrow.svg
// module id = 50
// module chunks = 0